module.exports = __webpack_public_path__ + "img/verified.ac4641b3.png";